<template>
  <div class="modal-content-poll">
    <div class="modal-header">
      <h2>Izmeni glasanje</h2>
    </div>
    <div class="body">
      <form class="form--mod" action="post">
        <div id="section">
          <div id="desc-area">
            <label class="col-form-label col-form-label-lg">Tekst objave</label>
            <textarea
              v-model="post.body"
              class="form-control"
              rows="5"
              id="comment"
              @focus="errorOccurred = false"
              ref="descArea"
            ></textarea>
          </div>
        </div>
      </form>
      <span class="txt-pin">Pinovana objava</span>
      <checkbox
        size="small"
        :checked="post.is_pinned == '1'"
        @change.native="togglePin()"
      ></checkbox>
    </div>

    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          @click="editForm"
        >
          <span v-if="!loading">Pošalji</span>
          <spinner line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapMutations, mapActions, mapState } from 'vuex';
import checkbox from '@/components/common/Checkbox.vue';

export default {
  components: {
    checkbox
  },
  data() {
    return {
      errorOccurred: false,
      errorMessage: ''
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('modal', ['post'])
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapActions('table', ['getPostsByCommunity']),
    ...mapMutations('modal', ['closeModal', 'setPoll']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations(['setPostTitle']),
    removeUploadedFile(index) {
      this.post.medias.splice(index, 1);
    },
    togglePin() {
      if (this.post.is_pinned == '1') {
        this.post.is_pinned = '0';
      } else {
        this.post.is_pinned = '1';
      }
    },
    editForm() {
      if (this.post.body === '') {
        this.errorOccurred = true;
        this.errorMessage = 'Morate popuniti polje opisa';
      } else {
        this.loadingStarted();
        axios
          .post('/post/edit', {
            body: this.post.body,
            post_id: this.post.postId,
            media_ids: this.post.medias
              ? this.post.medias.map(m => {
                  return m.id;
                })
              : []
          })
          .then(async data => {
            try {
              await axios.post('/post/pin', {
                member_id: this.$store.getters.getActiveCommunity.member_id,
                post_id: this.post.postId,
                pin: this.post.is_pinned == '1' ? true : false
              });
            } catch (error) {
              console.log(error);
              this.showFailModal();
              this.loadingFinished();
            }
            this.loadingFinished();
            this.getPostsByCommunity(this.$store.getters.getActiveCommunity.id);
            this.closeModal();
            this.showSuccessModal();
          })
          .catch(err => {
            console.log(err);
            this.showFailModal();
            this.loadingFinished();
          });
      }
    }
  }
};
</script>

<style lang="scss">
.modal-content-poll {
  .body {
    height: 100%;
    width: 100%;
  }

  .form--mod {
    justify-content: center;
  }

  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }
  .buttons {
    display: inline-flex;
    float: right;
  }

  .error {
    float: left;
    margin-left: 15px;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .btn-primary:hover {
    background-color: var(--primary-color-lighten);
  }

  .file {
    border-bottom: solid 1px lightgray;
    font-size: 15px;
    width: 100%;
    display: inline-flex;
    vertical-align: center;
    p {
      max-width: 155px;
      word-wrap: break-word;
      margin-bottom: 2px;
    }
  }

  .btn-primary:active {
    background-color: var(--primary-color) !important;
    border: none;
  }

  .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
  }

  textarea.form-control {
    resize: none;
    width: 100%;
  }

  #desc-area {
    width: 100%;
  }

  #section {
    display: inline-flex;
    width: 100%;
    height: 100%;
  }

  .del--mod {
    margin-left: auto;
    cursor: pointer;
    color: red;
    top: 4.7em;
    right: 1.7em;
  }

  #empty-files {
    text-align: center;
    color: grey;
    margin-top: 20%;
  }

  .col-form-label-lg {
    width: 100%;
    position: relative;
  }

  input {
    margin-bottom: 9px;
    position: relative;
  }

  #uploaded-files {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    height: 135px;
    resize: none;
    max-height: 134px;
    overflow-y: auto;
    padding: 5px;
  }

  #upload-area {
    display: block;
    margin-left: 9px;
    width: 34%;
    height: 100%;
  }

  .err-msg {
    text-align: center;
    color: red;
  }
  .form-control {
    margin-left: 2px;
  }
}
</style>
